module.exports = __webpack_public_path__ + "static/30afedc3f4c407e52af461688102df4c4342b81cd9f450dc82db2eda6e3a4bb8-058ad1a3f2f0d21457e9727ee59df26a.png";